import { render } from "./CGVContent.vue?vue&type=template&id=3a3a8ce3&scoped=true"
import script from "./CGVContent.vue?vue&type=script&lang=js"
export * from "./CGVContent.vue?vue&type=script&lang=js"

import "./CGVContent.vue?vue&type=style&index=0&id=3a3a8ce3&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3a8ce3"]])

export default __exports__